import { render, staticRenderFns } from "./AppNames.vue?vue&type=template&id=ac8f64f0&scoped=true"
import script from "./AppNames.vue?vue&type=script&lang=ts"
export * from "./AppNames.vue?vue&type=script&lang=ts"
import style0 from "./AppNames.vue?vue&type=style&index=0&id=ac8f64f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8f64f0",
  null
  
)

export default component.exports